/**
 * Endonyms, so a reader can find their language in a list they cannot otherwise
 * read. Kept deliberately ahead of `resources`: adding a locale should not also
 * mean editing this map, or the switcher renders a bare code that day.
 */
export const LOCALE_LABELS: Record<string, string> = {
  /* eslint-disable i18next/no-literal-string -- endonyms, never translated */
  en: 'English (United States)',
  es: 'Español',
  pt: 'Português',
  fr: 'Français (France)',
  de: 'Deutsch (Deutschland)',
  hi: 'हिन्दी (भारत)',
  id: 'Indonesia (Indonesia)',
  it: 'Italiano (Italia)',
  ja: '日本語 (日本)',
  ko: '한국어(대한민국)',
  'pt-BR': 'Português (Brasil)',
  'es-419': 'Español (Latinoamérica)',
  'es-ES': 'Español (España)',
  /* eslint-enable i18next/no-literal-string */
};

/**
 * The locales the switcher offers. Explicit rather than derived from the loaded
 * bundles, because only `en` is loaded at boot: deriving it would hide every
 * translation behind a switcher that never lists it. `locales.test.ts` ties this
 * to the static catalogue and to the loader map, so the three cannot drift.
 */
export const SUPPORTED_LOCALE_CODES: readonly string[] = [
  /* eslint-disable i18next/no-literal-string -- BCP-47 tags, not copy */
  'en',
  'es',
  'pt',
  /* eslint-enable i18next/no-literal-string */
];

export interface SupportedLocale {
  code: string;
  label: string;
}

/**
 * Listing a code here is the only gate, and it happens before the catalogue is
 * fetched, so `locale-coverage.test.ts` requiring full parity is what keeps a
 * half-translated locale off the menu.
 */
export function getSupportedLocales(): SupportedLocale[] {
  return SUPPORTED_LOCALE_CODES.map((code) => ({
    code,
    label: LOCALE_LABELS[code] ?? code,
  }));
}
